import React, {useContext, useEffect, useRef} from "react";

import SurveyAssistantUtils from "./SurveyAssistantUtils";
import SurveyAssistantMessageBox from "./SurveyAssistantMessageBox";
import SurveyAssistantService from "../../../services/SurveyAssistantService";
import SurveysService from "../../../services/SurveysService";
import {DateTime} from "luxon";
import {useDispatch} from "react-redux";

function SurveyAssistantChat(props) {

    let {
        addMessage,
        addMessages,
        messagesList,
        conversation,
        handleGetSurvey,
        surveyId,
    } = props;

    const MOBILE_WIDTH = 992;

    const dispatch = useDispatch();

    const listBottomElemRef = useRef();
    const chatTextAreaRef = useRef();
    const fakeChatTextAreaRef = useRef();

    const [awaitingResponse, setAwaitingResponse] = React.useState(false);
    const [awaitingResponseText, setAwaitingResponseText] = React.useState(undefined);
    const [errorSendMessage, setErrorSendMessage] = React.useState(false);
    const [promptText, setPromptText] = React.useState("");
    const [internetSearchText, setInternetSearchText] = React.useState(undefined);

    const [textAreaHeight, setTextAreaHeight] = React.useState(92);

    useEffect(() => {
        // chatTextAreaRef.current.style.height = 'auto';
        // chatTextAreaRef.current.style.height = `${chatTextAreaRef.current.scrollHeight}px`;
        // fakeChatTextAreaRef.current.style.height = `${chatTextAreaRef.current.scrollHeight}px`;

        if (chatTextAreaRef.current && fakeChatTextAreaRef.current) {
            // Reset height before recalculating
            chatTextAreaRef.current.style.height = "auto";

            // Get new height, but limit it to 50vh
            let newHeight = Math.min(chatTextAreaRef.current.scrollHeight, window.innerHeight * 0.5);

            // Apply new height to textarea
            chatTextAreaRef.current.style.height = `${newHeight}px`;

            // Apply new height to fake chat box
            fakeChatTextAreaRef.current.style.height = `${newHeight}px`;

            // Update state to sync UI
            setTextAreaHeight(newHeight);
        }
    }, [promptText]);

    useEffect(() => {
        if (messagesList && messagesList.length > 0) {
            listBottomElemRef.current.scrollIntoView();
        }
    }, [messagesList]);

    const handleChatKeyDownEvent = (event) => {
        if(awaitingResponse) return;
        if (event.key !== "Enter") return;

        // shift + enter by default inputs a new line
        if (event.shiftKey) return;

        if (event.altKey) {
            event.preventDefault();
            const cursorPos = event.target.selectionStart;
            // alt + enter doesn't by default add a a new line
            const newValue = promptText.slice(0, cursorPos) + "\n" + promptText.slice(cursorPos);
            setPromptText(newValue);

            // we need this to update the cursor position after react updates the DOM
            setTimeout(() => event.target.setSelectionRange(cursorPos + 1, cursorPos + 1), 0);
            return;
        }
        
        handleChatTextSubmit(event);
    };

    const handleChatTextSubmit = (event) => {
        if(!promptText || promptText === "\n") return;

        const newMessage = SurveyAssistantUtils.getDefaultMessage();
        newMessage.data.type = 'user_input';
        newMessage.data.text = promptText.trim();
        newMessage.data.createdDate = DateTime.local().toMillis();

        addMessage(newMessage);
        sendMessageToAssistant(newMessage);

        setPromptText("");
        event.preventDefault();
    }

    const sendMessageToAssistant = async (userMessage, isRetry) => {
        setAwaitingResponse(true);
        setInternetSearchText(undefined);

        let localConversationId = conversation && conversation.id ? conversation.id : null;

        if (!localConversationId) {
            SurveysService.getOrCreateConversationForSurveyId(surveyId, null,
                (success) => {
                    localConversationId = success.data.id;
                    setConversation(success.data);
                    sendMessageAfterConversationCreation(userMessage, isRetry, localConversationId);
                }, 
                (error) => {
                    setErrorSendMessage(true);
                    setAwaitingResponse(false);
                }
            );
        }else{
            sendMessageAfterConversationCreation(userMessage, isRetry, localConversationId);
        }

    }

    const sendMessageAfterConversationCreation = (userMessage, isRetry, localConversationId) => {
        let auxiliaryMessagesList = [];
        if (!isRetry) {
            auxiliaryMessagesList.push(userMessage);
        }
        const requestPayload = {
            message: userMessage.data,
            conversationId: localConversationId
        };

        setAwaitingResponseText(SurveyAssistantUtils.getRandomAwaitingResponseMessage());
        let awaitingResponseTextInterval = setInterval(() => {
            setAwaitingResponseText(SurveyAssistantUtils.getRandomAwaitingResponseMessage());
        }, 5000);

        let webSearchRequestInterval;

        SurveyAssistantService.sendMessageAndRetrieveResponseFromAssistant(requestPayload,
            (success) => {
                const assistantMessage = SurveyAssistantUtils.getDefaultMessage();
                assistantMessage.data = success.data.message;

                auxiliaryMessagesList.push(assistantMessage);
                addMessages(auxiliaryMessagesList);
                console.log("LOOK HERE!! ", success)

                if (success.data.conversation) {
                    setConversation(success.data.conversation);

                }

                if (success.data && success.data.survey) {
                    // THIS IS A HACK
                    success.data.survey.type = "test"
                    success.data.survey.active = false
                    handleGetSurvey(success.data.survey)
                }

                setAwaitingResponse(false);
                clearInterval(webSearchRequestInterval);
                clearInterval(awaitingResponseTextInterval);
            },
            (error) => {
                addMessages(auxiliaryMessagesList);

                setErrorSendMessage(true);
                setAwaitingResponse(false);
                clearInterval(webSearchRequestInterval);
                clearInterval(awaitingResponseTextInterval);
            }
        );

        webSearchRequestInterval = setInterval(() =>
                SurveyAssistantService.getInternetSearchQuery(localConversationId,
                    (success) => {
                        const keywords = success.data;

                        if (!keywords) {
                            return;
                        }

                        const message = `In order to access up-to-date information we’re searching the Internet for '${keywords}'`;
                        setInternetSearchText(message);
                        clearInterval(webSearchRequestInterval);
                    }, (error) => {
                        console.log(error);
                    }
                )
            , 3000);
    }
    const handleRetrySendMessage = () => {
        setErrorSendMessage(false);
        sendMessageToAssistant(messagesList[messagesList.length - 1], true);
    }
    const setConversation = (conv) => {
        conversation = conv;
    }
    const getMessageLabelByType = (type) => {
        switch (type) {
            case 'user_input':
                return 'User Input';
            case 'assistant_response':
                return 'Assistant Response';
            default:
                return 'Unknown';
        }
    }

    const createHtmlFromMessagesList = () => {
        const introMessage = {
            ...SurveyAssistantUtils.getDefaultMessage(),
            data: {
                type: 'assistant_response',
                text: `Hello! I am here to help you with your survey.`,
                createdDate: Array.isArray(messagesList) && messagesList.length > 0 && messagesList[0].data.createdDate
                    ? messagesList[0].data.createdDate
                    : DateTime.local().toMillis()
            }
        };
        const messagesListWithIntro = [introMessage].concat(messagesList);

        return messagesListWithIntro.map((message, index) => {
            return (
                <SurveyAssistantMessageBox key={'assistant_chat_paragraph_idx_' + index}
                                           text={message.data.text}
                                           type={message.data.type}
                                           createdDate={message.data.createdDate}
                                           error={message.error}
                />
            );
        })
    }

    const handleOnChangeForMessageInput = (event) => {
        setPromptText(event.target.value);
    }

    const chatMessagesHtml = createHtmlFromMessagesList();

    const hideChatSectionOnMobileClass = (window.innerWidth < MOBILE_WIDTH ? " d-none " : "");

    const chatWidthValue = "100%";

    return (
        <div id="assistantChatSection" className={"container-md w-100 p-0 " + hideChatSectionOnMobileClass}>
            <div className="d-flex flex-column position-relative">
                {/* CHAT MESSAGES */}

                <div className="chat-body overflow-auto py-3 messages-align-bottom" style={{
                    paddingBottom: `${textAreaHeight}px`,  // Avoid overlap
                    scrollbarWidth: "thin",
                    paddingLeft: "1em",
                    paddingRight: "1em",
                    paddingTop: "1.25em !important",
                    height: "60vh"
                }}>
                    {chatMessagesHtml}
                    {awaitingResponse &&
                        <SurveyAssistantMessageBox awaitingText={awaitingResponseText}
                                                   type={'assistant_response'}
                                                   internetSearchText={internetSearchText}
                        />
                    }
                    {errorSendMessage &&
                        <SurveyAssistantMessageBox text={"Error sending message."}
                                                   type={'assistant_response'}
                                                   error={true}
                                                   handleRetrySendMessage={handleRetrySendMessage}
                        />
                    }
                    <div ref={listBottomElemRef}/>
                </div>

                {/* CHAT MESSAGES */}

                {/* CHAT INPUT */}

                {/* Fake chat input div, so that when the sticky chat input height extends, this will extend as well!*/}
                {/* <div className="chat-footer w-100" style={{
                }}>
                    <div id="fake-chat-text-box"
                         style={{
                             height: `${textAreaHeight}px`,
                             transition: "height 0.2s ease-in-out"
                         }}
                         ref={fakeChatTextAreaRef}
                    >
                    </div>
                </div> */}

                <div className="chat-footer py-3 w-100 "
                     style={{
                        paddingRight: "calc(var(--bs-gutter-x)* .5)",
                        paddingLeft: "calc(var(--bs-gutter-x)* .5)",
                        background: "#eff2f6"
                     }}

                     ref={(node) => {
                         /* React does not support '!important' by design, this is a workaround to set a property with important */
                         if (node) {
                             node.style.setProperty("width", chatWidthValue, "important");
                         }
                     }}
                >
                    <div className="">
                        <div className="row g-0 d-flex justify-content-center align-items-center">
                            <div className="col">
                                <div className="form">
                                    <textarea id="chat-text-box"
                                              style={{
                                                  height: `${textAreaHeight}px`,
                                                  maxHeight: "50vh",
                                                  overflowY: textAreaHeight >= window.innerHeight * 0.5 ? "auto" : "hidden",
                                                  resize: "none",
                                                  width: "100%",
                                                  transition: "height 0.2s ease-in-out"
                                              }}
                                            rows="2"
                                            ref={chatTextAreaRef}
                                            className="form-control rounded-3 px-3"
                                            placeholder={"Message assistant..."}
                                            disabled={ errorSendMessage }
                                            value={promptText}
                                            onChange={handleOnChangeForMessageInput}
                                            onKeyDown={handleChatKeyDownEvent}
                                    />
                                </div>
                            </div>
                            <div className="col-auto chat-button-parent">
                                <button className="btn btn-icon btn-primary rounded-circle ms-2 "
                                        disabled={awaitingResponse || errorSendMessage }
                                        onClick={handleChatTextSubmit}
                                >
                                    <i className="fa-solid fa-arrow-up text-white"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* CHAT INPUT */}

            </div>
        </div>
    );
}

export default SurveyAssistantChat;